export const LANGUAGE_QUERY_PARAM = 'lang';

/**
 * Get language from url.
 * @returns {string}
 */
export function getLanguagueFromUrl() {
  const langFromQuery = new URLSearchParams(window.location.search).get(LANGUAGE_QUERY_PARAM);
  if (langFromQuery) {
    return langFromQuery;
  }

  // Detect Spanish from URL path (e.g., /food-handlers-card/california-espanol)
  if (window.location.pathname.includes('espanol')) {
    return 'es';
  }

  return 'en'; // default language
}
